import { useTranslation } from "react-i18next";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import styles from "./ReturnDelivery.module.scss";

const ReturnDelivery = () => {
  const { t } = useTranslation("translation");

  return (
    <div className={styles.return_delivery}>
      <TitleUpdater title={t("return_delivery")} />
      <div className="container">
        <div className={styles.content}>
          <h1 className={styles.title}>{t("order_returns_policy")}</h1>

          <section className={styles.section}>
            <h2 className={styles.section_title}>{t("our_promise")}</h2>
            <div className={styles.section_content}>
              <p>{t("promise_content.0")}</p>
              <p className={styles.note}>{t("promise_content.1")}</p>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.section_title}>{t("domestic_delivery")}</h2>
            <div className={styles.section_content}>
              <ul>
                <li>{t("domestic_content.0")}</li>
                <li>{t("domestic_content.1")}</li>
                <li>{t("domestic_content.2")}</li>
                <li>{t("domestic_content.3")}</li>
              </ul>
              <p className={styles.note}>{t("domestic_note")}</p>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.section_title}>
              {t("international_delivery")}
            </h2>
            <div className={styles.section_content}>
              <ul>
                <li>{t("international_content.0")}</li>
                <li>{t("international_content.1")}</li>
                <li>{t("international_content.2")}</li>
              </ul>
              <p className={styles.note}>{t("international_note")}</p>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.section_title}>{t("order_tracking")}</h2>
            <div className={styles.section_content}>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("tracking_content") || "",
                }}
              />
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.section_title}>
              {t("return_exchange_policy")}
            </h2>
            <div className={styles.section_content}>
              <ul>
                <li>{t("return_content.0")}</li>
                <li>{t("return_content.1")}</li>
                <li
                  dangerouslySetInnerHTML={{
                    __html: t("return_content.2") || "",
                  }}
                />
                <li>{t("return_content.3")}</li>
                <li
                  dangerouslySetInnerHTML={{
                    __html: t("return_content.4") || "",
                  }}
                />
              </ul>
              <p className={styles.note}>{t("return_note")}</p>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.section_title}>{t("refunds")}</h2>
            <div className={styles.section_content}>
              <ul>
                <li>{t("refunds_content.0")}</li>
                <li>{t("refunds_content.1")}</li>
                <li>{t("refunds_content.2")}</li>
              </ul>
            </div>
          </section>

          <section className={styles.section}>
            <h2 className={styles.section_title}>{t("exceptions_notes")}</h2>
            <div className={styles.section_content}>
              <ul>
                <li
                  dangerouslySetInnerHTML={{
                    __html: t("exceptions_content.0") || "",
                  }}
                />
                <li>{t("exceptions_content.1")}</li>
                <li>{t("exceptions_content.2")}</li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ReturnDelivery;
